import Link from 'next/link'
import styled from 'styled-components'

import { theme } from '@/styles/theme'
import { IR_TOP_ROUTE } from '@/utils/routes'

import { Button } from '@/components/elements/Button'

import type { IrCalendar } from '@/types/irCalendar'

const calenderLink = IR_TOP_ROUTE.subdirectories[6].path

type IrCalendarProps = {
  items: IrCalendar[]
}
export const CalenderCard = ({ items }: IrCalendarProps) => {
  const maxLength = 3
  const displayItems = [...items]
    .sort((a, b) => new Date(b.published).getTime() - new Date(a.published).getTime())
    .slice(0, maxLength); 
  return (
    <Card>
      <Title>IRカレンダー</Title>
      <CalenderList>
        {displayItems.map(( item, index ) => (
          <li key={index}>
            <time>{formatDate(item.published)}</time>  
            <a href={item.link} target={item.target}>{item.title}</a>
          </li>
        ))}
      </CalenderList>
      <Link href={calenderLink} passHref>
        <a>
          <LinkButton btnStyle="transparent">IRカレンダー</LinkButton>
        </a>
      </Link>
    </Card>
  )
}

const formatDate = (date: string | Date) => {
  return new Date(date).toLocaleDateString("zh-CN", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const Card = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 22px 20px;
  gap: 20px;
  background: ${theme.colors.backgroundGrey};
  border-radius: 8px;
`

const Title = styled.h2`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 0px 12px;
  width: 100%;
  height: 38px;
  border-bottom: 1px solid ${theme.colors.grey};
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  @media screen and (max-width: 1047px) {
    height: 36px;
    font-size: 20px;
  }
`

const CalenderList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  padding: 0px;
  width: 200px;

  > li {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 6px;
    font-size: 15px;
    line-height: 1.2;

    > time {
      font-size: 12px;
      color: ${theme.colors.textSecond};
    }

    // 非アンカー要素
    > div {
    }

    // アンカー要素
    > a {
      transition: color 0.3s ease;
      &:hover {
        color: ${theme.colors.lightBlue};
        text-decoration: underline;
      }
    }
  }

  @media screen and (max-width: 1047px) {
    width: 295px;
  }
`

const LinkButton = styled(Button)`
  width: 200px;
  height: 42px;
  padding: 7px 26px 9px;
  font-weight: 500;
  font-size: 16px;
  line-height: 1;
  background-color: #ffffff;

  @media screen and (max-width: 1047px) {
    width: 295px;
    height: 42px;
  }
`
